<template>
  <slot
    :styles="styles"
    :is-constrained-start="isConstrainedStart"
    :is-constrained-end="isConstrainedEnd"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import useDateConstrain, {
  type Props as UseDateConstrainProps,
} from '@/composition/useDateConstrain'

export interface Props extends UseDateConstrainProps {
  startDate: Date
  endDate: Date
}

export interface Slots {
  default: (props: {
    styles: { gridColumn: string }
    isConstrainedStart: boolean
    isConstrainedEnd: boolean
  }) => unknown
}

const props = withDefaults(defineProps<Props>(), {
  useDateConstrain: true,
})

defineSlots<Slots>()

const {
  startsOnRelativeDay,
  numberOfDaysConstrained,
  isConstrainedStart,
  isConstrainedEnd,
} = useDateConstrain(props)

const styles = computed(() => {
  let columnStart = (startsOnRelativeDay.value ?? 0) + 1
  const columnSpan = numberOfDaysConstrained.value

  // TODO Throw an error when `startsOnRelativeDay` is not defined
  if ((startsOnRelativeDay.value ?? 0) < 0) {
    columnStart = 1
  }

  return {
    gridColumn: `${columnStart} / span ${columnSpan}`,
  }
})
</script>
